import { BaseModel } from './base';

export class LeaveLevel extends BaseModel {
  levelName: string;

  subscriberId: string;
  siteId: string;
  id: string;
}
